import { createContext } from 'react'

export const MathFieldContext = createContext({})
